export default __webpack_public_path__ + "static/media/chicks.f6ff4348.svg";